(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/prescript.js'); 'use strict';

svs.sport = svs.sport || {};
svs.sport.result_boxes = svs.sport.result_boxes || {};

svs.sport.result_boxes.graph = svs.sport.result_boxes.graph || {};
svs.sport.result_boxes.views = svs.sport.result_boxes.views || {};
svs.sport.result_boxes.models = svs.sport.result_boxes.models || {};
svs.sport.result_boxes.constants = svs.sport.result_boxes.constants || {};

svs.sport.result_boxes.constants = {
  FINALIZED: 20,
  REGCLOSED: 3,
  CANCELCLOSED: 4,
  matchStatus: {
    NOT_STARTED: 0,
    FIRST_PERIOD: 1,
    SECOND_PERIOD: 2,
    THIRD_PERIOD: 3,
    FOURTH_PERIOD: 4,
    FIFTH_PERIOD: 5,
    FIRST_HALF: 6,
    SECOND_HALF: 7,
    FIRST_SET: 8,
    SECOND_SET: 9,
    THIRD_SET: 10,
    FOURTH_SET: 11,
    FIFTH_SET: 12,
    STARTED: 13,
    PAUSE: 14,
    HALF_TIME: 15,
    AWAITING_EXTRA_TIME: 16,
    EXTRA_TIME_HALF_TIME: 17,
    AWAITING_PENALTIES: 18,
    IN_OVERTIME: 19,
    IN_FIRST_EXTRA_PERIOD: 20,
    IN_SECOND_EXTRA_PERIOD: 21,
    IN_PENALTIES: 22,
    POSTPONED: 23,
    START_DELAYED: 24,
    CANCELLED: 25,
    INTERRUPTED: 26,
    SUSPENDED: 27,
    ABANDONED: 28,
    WALKOVER: 29,
    PARTICIPANT_RETIRED: 30,
    ENDED: 31,
    ENDED_AFTER_EXTRA_TIME: 32,
    ENDED_AFTER_PENALTIES: 33,
    IN_FIRST_BREAK: 34,
    IN_SECOND_BREAK: 35,
    IN_THIRD_BREAK: 36,
    FIRST_QUARTER: 37,
    SECOND_QUARTER: 38,
    THIRD_QUARTER: 39,
    FOURTH_QUARTER: 40,
    FINISHED: 41
  },
  productName: {
    BOMBEN: 'bomben',
    POWERPLAY: 'powerplay',
    CHALLENGE: 'challenge'
  },
  sports: {
    TROTTING: 1000060,
    FOTBOLL: 1000002,
    HOCKEY: 1000003
  },
  eventTypes: {
    EVENT_1X2: 1,
    EVENT_OVER_UNDER: 4,
    EVENT_H2H: 12,
    EVENT_TOTALT_ANTAL_MAL: 16,
    EVENT_BADA_LAGEN_GOR_MINST: 28,
    EVENT_12: 31
  }
};

 })(window);